var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version-detail"},[_c('md-card',[_c('md-card-header',[_c('h1',[_vm._v(_vm._s(_vm.version.version))]),_c('span',[_vm._v("("+_vm._s(_vm.version.hash)+")")])]),_c('md-card-header',[_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.version.date)))])]),_c('md-card-content',{domProps:{"innerHTML":_vm._s(_vm.version.description)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }